<div class="flex-column gap-M" [ngClass]="{ 'pad-L': !_loading && (globalAppCount !== undefined && globalAppCount > 0), 'no-app-background': (globalAppCount !== undefined && globalAppCount <= 0) }" style="min-width: 950px; margin-top: 5px;" [style.height]="_loading || (globalAppCount !== undefined && globalAppCount <= 0) ? 'calc(100% - 85px)' : ''">
    <div class="flex gap-M header-container" [ngClass]="{ 'w-100': !_loading && (globalAppCount !== undefined && globalAppCount > 0), 'pad-L': _loading || (globalAppCount !== undefined && globalAppCount <= 0), 'w-auto': _loading || (globalAppCount !== undefined && globalAppCount <= 0) }">
		<app-application-list-filter class="w-100" (filterChanged)="onFilterChanged($event)"></app-application-list-filter>
		<div class="flex-align-center filter-bar bkg-white b-radius-9" style="padding: 3px;">
            <app-text-button type="default" color="primary"  style="width: 43px; height: 43px;" panelClass="h-100-imp pad-0-imp"
                             [matMenuTriggerFor]="selectMenu" [disabled]="_initializing || _loading" [loading]="_exporting">
                <div class="flex-center">
                    <img src="assets/icons/dots-vertical.svg" height="18" alt=""/>
                </div>
            </app-text-button>
            <mat-menu #selectMenu class="mat-menu-custom"
                      xPosition="before" yPosition="below">
                <div class="flex-align-center gap-M greyed-hover b-radius-6 c-p" style="padding: 6px;"
                     (click)="exportCsv()">
                    <img src="assets/icons/share.svg" width="18" height="18" alt=""/>
                    <div class="font-M fw-500">{{'page.application.table.filters.export'|translate}}</div>
                </div>
                <div class="flex-align-center gap-M greyed-hover b-radius-6 c-p" style="padding: 6px;"
                     (click)="exportXlsx()">
                    <img src="assets/icons/layout-grid-02.svg" width="18" height="18" alt=""/>
                    <div class="font-M fw-500">{{'page.application.table.filters.exportX'|translate}}</div>
                </div>
            </mat-menu>
        </div>
        <app-text-button type="stroked" color="accent-secondary" panelClass="h-100-imp b-radius-9"
                         [badge]="pendingAutodiscoverAppCount > 0 ? pendingAutodiscoverAppCount : undefined"
                         [disabled]="_initializing || _loadingAutoDiscover"
                         (click)="openAutoDiscoverDrawer()">
            <div class="flex-align-center gap-S">
                <img src="assets/icons/sonar.svg" width="26" height="26" style="margin-left: -6px; margin-bottom: -3px;" alt=""/>
                <span class="font-M fw-500">{{'page.application.table.autoDiscover'|translate}}</span>
            </div>
        </app-text-button>
        <app-text-button *ngIf="isEditor" type="flat" color="accent" panelClass="h-100-imp b-radius-9"
                         [disabled]="_initializing"
                         (click)="openCreateApplication()">
            <span class="font-M fw-500">{{'page.application.table.addApplication'|translate}}</span>
        </app-text-button>
    </div>

    <div *ngIf="globalAppCount !== undefined && globalAppCount > 0 && !_loading" class="flex-column app-list-content bkg-white">
        <table class="app-list-table" aria-describedby="apps" [style.height]="applicationRows.length <= 0 ? 'calc(100vh - 193px)' : ''">
            <tr class="app-list-header">
                <th>
                    <div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p" style="border-top-left-radius: 14px; padding-left: 67px;"
                         [ngClass]="{'sort-active': sortFormValue.column === column.NAME}"
                         (click)="sortBy(column.NAME)">
                        <span class="font-M fw-500 text-left grey">{{'page.application.table.name'|translate}}</span>
                        <img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10" alt=""
                             [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.NAME ? '90' : '-90') + 'deg)'}">
                    </div>
                </th>
                <th>
                    <div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
                         [ngClass]="{'sort-active': sortFormValue.column === column.HEALTH}"
                         (click)="!_loading ? sortBy(column.HEALTH) : {}">
                        <span class="font-M fw-500 text-left grey">{{'page.application.table.health'|translate}}</span>
                        <img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10" alt=""
                             [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.HEALTH ? '90' : '-90') + 'deg)'}">
                    </div>
                </th>
                <th>
                    <div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
                         [ngClass]="{'sort-active': sortFormValue.column === column.CATEGORY}"
                         (click)="sortBy(column.CATEGORY)">
                        <span class="font-M fw-500 text-left grey">{{'page.application.table.category'|translate}}</span>
                        <img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10" alt=""
                             [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.CATEGORY ? '90' : '-90') + 'deg)'}">
                    </div>
                </th>
                <th>
                    <div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
                         [ngClass]="{'sort-active': sortFormValue.column === column.CRITICALITY}"
                         (click)="sortBy(column.CRITICALITY)">
                        <span class="font-M fw-500 text-left grey">{{'page.application.table.criticality'|translate}}</span>
                        <img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10" alt=""
                             [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.CRITICALITY ? '90' : '-90') + 'deg)'}">
                    </div>
                </th>
                <th>
                    <div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p"
                         [ngClass]="{'sort-active': sortFormValue.column === column.USAGE}"
                         (click)="!_loading ? sortBy(column.USAGE) : {}">
                        <span class="font-M fw-500 text-left grey">{{'page.application.table.users'|translate}}</span>
                        <img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10" alt=""
                             [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.USAGE ? '90' : '-90') + 'deg)'}">
                    </div>
                </th>
                <th>
                    <div class="flex-align-center gap-S pad-0-S greyed-hover sort-column c-p" style="border-top-right-radius: 14px;"
                         [ngClass]="{'sort-active': sortFormValue.column === column.COST}"
                         (click)="sortBy(column.COST)">
                        <span class="font-M fw-500 text-left grey">{{'page.application.table.cost'|translate}}</span>
                        <img src="assets/icons/arrow-right-black.svg" class="filter-grey" height="10" alt=""
                             [ngStyle]="{'transform': 'rotate(' + (sortFormValue.direction === direction.DESC && sortFormValue.column === column.COST ? '90' : '-90') + 'deg)'}">
                    </div>
                </th>
            </tr>
            @for (app of applicationRows; track app.instance.applicationId) {
                <tr class="app-list-row font-M fw-500 greyed-hover c-p"
                    (click)="openApplicationDrawer(app.instance.applicationId)">
                    <td class="w-25">
                        <div class="flex" style="max-width: 300px; padding-left: 3px;">
                            <app-display-application class="w-100" size="L" [application]="app.instance" [description]="app.instance.description" bold></app-display-application>
                        </div>
                    </td>
                    <td class="w-10">
                        <div class="flex">
                            <app-chips-health [health]="!app.instance.usageActivated ? null : app.health" tooltipPosition="right"
                                              [tooltip]="('page.appDetails.usage.tooltipHistogramDeactivated1'|translate) + ' ' + ('page.appDetails.usage.settings'|translate)"
                                              [tooltipDisabled]="app.instance.usageActivated"></app-chips-health>
                        </div>
                    </td>
                    <td class="w-20">
                        <span class="font-M fw-500">{{app.category?.name}}</span>
                    </td>
                    <td class="w-10">
                        <div class="flex">
                            <app-chips-criticality [criticality]="app.instance.criticality" short></app-chips-criticality>
                        </div>
                    </td>
                    <td class="w-10">
                        <div class="flex">
                            <app-chips-count [value]="!app.instance.usageActivated ? undefined : app.usage?.value || 0" type="user" bold tooltipPosition="right"
                                             [tooltip]="('page.appDetails.usage.tooltipHistogramDeactivated1'|translate) + ' ' + ('page.appDetails.usage.settings'|translate)"
                                             [tooltipDisabled]="app.instance.usageActivated"></app-chips-count>
                        </div>
                    </td>
                    <td class="w-25">
                        <div class="flex-space-between pad-right-S">
                            <span class="font-M fw-500">
                                {{(app.cost.value|cost)}}
                            </span>
                            <img src="assets/icons/arrow-right.svg" width="9" alt=""/>
                        </div>
                    </td>
                </tr>
            } @empty {
				<tr>
					<td colspan="6">
						<div class="flex-center flex-column gap-XL">
							<img src="assets/illustrations/empty-app.svg">
							<span class="grey">{{'page.application.table.noData'|translate}}</span>
						</div>
					</td>
				</tr>
			}
        </table>
        <div *ngIf="applicationRows.length > 0" class="app-list-footer bkg-white">
            <div class="font-M fw-500 pad-M grey">{{'Total ' + applicationRows.length + ' application(s)'}}</div>
        </div>
    </div>
	<div *ngIf="_loading" class="h-100 flex-justify-center flex-align-center flex-column gap-20">
		<app-spinner color="grey" [scale]="0.8"></app-spinner>
	</div>
	<div *ngIf="globalAppCount !== undefined && globalAppCount <= 0 && !_loading" class="h-100 flex-justify-center flex-align-center flex-column gap-20">
		<span class="font-XL fw-700 text-center primary">{{ 'page.application.noApplication.1' | translate }}</span>
		<span *ngIf="isEditor" class="fw-500 text-center font-L primary" style="line-height: 1.6rem;">
            {{ 'page.application.noApplication.2' | translate }}
            <span class="fw-700">{{ 'page.application.noApplication.3' | translate }}</span>
            {{ 'page.application.noApplication.4' | translate }}
            <span class="fw-700">{{ 'page.application.noApplication.5' | translate }}</span>
            {{ 'page.application.noApplication.6' | translate }}<br>
			{{ 'page.application.noApplication.7' | translate }}
        </span>
		<app-text-button *ngIf="isEditor" (click)="openCreateApplication()" class="mt-l w-20" style="min-width: 200px;" color='accent' type='flat'>
			{{ 'global.letsGo' | translate }}
		</app-text-button>
	</div>
</div>
